import axios from 'axios';
import { req } from './axiosFun';
const devEnv = require('../../config/index')

/**
 * 系统配置-工厂
 */

//修改工厂名称
export function uptFactory(param) {
    return req("post", devEnv.API_ROOT + "/factory/save", param);
}
//查询工厂列表
export function queryFactoryList(param) {
    return req("post", devEnv.API_ROOT + "/factory/getList", param);
}
//通过工厂ID查询工厂详情
export function queryFactoryById(_id) {
    return req("post", devEnv.API_ROOT + "/factory/getInfo?_id=" + _id);
}
//批量删除工厂
export function delFactoryBatch(param) {
    return req("post", devEnv.API_ROOT + "/factory/batchDelete", param);
}

//通过工厂ID删除工厂
export function delFactoryById(_id) {
    return axios.get(devEnv.API_ROOT + "/factory/delete?_id=" + _id).then(res => res.data);
}

//修改工厂名称新
export function uptFactoryNew(param) {
    return req("post", devEnv.API_ROOT + "/factory/changeFactoryName", param);
}

/**
 * 系统配置-部门
 */
//查询部门列表
export function queryDeptList(param) {
    return req("post", devEnv.API_ROOT + "/user/getDeptList", param);
}

//通过部门ID删除部门
export function delDeptById(_id) {
    return axios.get(devEnv.API_ROOT + "/user/deleteDept?_id=" + _id).then(res => res.data);
}

//添加/编辑部门
export function addUptDept(param) {
    return req("post", devEnv.API_ROOT + "/user/saveDept", param);
}

/**
 * 系统配置-用户
 */
//用户启用
export function activeUser(_id) {
    return axios.get(devEnv.API_ROOT + "/user/active?_id=" + _id).then(res => res.data);
}
//用户停用
export function deactiveUser(_id) {
    return axios.get(devEnv.API_ROOT + "/user/deactive?_id=" + _id).then(res => res.data);
}
//复制权限（移动端、web端）
export function copyAuthority(param) {
    return req("post", devEnv.API_ROOT + "/user/copyAuthority", param);
}

//查询所有用户列表
export function queryAllUserList(factoryId) {
    return axios.get(devEnv.API_ROOT + "/user/getAll?factoryId=" + factoryId).then(res => res.data);
}

//查询用户列表
export function queryUserList(param) {
    return req("post", devEnv.API_ROOT + "/user/getList", param);
}

//添加和编辑用户
export function addUptUser(param) {
    return req("post", devEnv.API_ROOT + "/user/save", param);
}

//重置密码
export function resetPwd(param) {
    return req("post", devEnv.API_ROOT + "/user/setPassword", param);
}

//虚拟用户，非虚拟用户切换
export function switchUser(_id, virtualUser) {
    return axios.get(devEnv.API_ROOT + "/user/switchType?_id=" + _id + "&virtualUser=" + virtualUser).then(res => res.data);
}

//修改权限（移动端、web端）
export function uptAuthority(param) {
    return req("post", devEnv.API_ROOT + "/user/updateAuthority", param);
}


/**
 * 自定义配置
 */
//查询自定义配置列表
export function queryCustomSet(param) {
    return req("post", devEnv.API_ROOT + "/customSet/getList", param);
}

//建和编辑自定义配置
export function addUptCustomSet(param) {
    return req("post", devEnv.API_ROOT + "/customSet/save", param);
}
//查询所有自定义配置
export function queryAllCustomSet(factoryId, collection) {
    return axios.get(devEnv.API_ROOT + "/customSet/getAll?factoryId=" + factoryId + "&collection=" + collection).then(res => res.data);
}
//删除自定义配置
export function delCustomSet(_id) {
    return axios.get(devEnv.API_ROOT + "/customSet/delete?_id=" + _id).then(res => res.data);
}

//查询自定义编号规则列表
export function queryCustomRule(param) {
    return req("post", devEnv.API_ROOT + "/codeRule/getList", param);
}

//建和编辑自定义配置
export function addUptCustomRule(param) {
    return req("post", devEnv.API_ROOT + "/codeRule/save", param);
}

/**
 * 销售订单
 */

//查询销售订单列表
export function querySalesOrderList(param) {
    return req("post", devEnv.API_ROOT + "/salesOrder/getList", param);
}
//创建和编辑销售订单
export function addUptSalesOrder(param) {
    return req("post", devEnv.API_ROOT + "/salesOrder/save", param);
}
//批量删除销售订单
export function batchDelSalesOrder(param) {
    return req("post", devEnv.API_ROOT + "/salesOrder/batchDelete", param);
}

//查询所有销售订单
export function queryAllSalesOrder(factoryId) {
    return axios.get(devEnv.API_ROOT + "/salesOrder/getAll?factoryId=" + factoryId).then(res => res.data);
}

//删除销售订单
export function delSalesOrder(param) {
    return req("post", devEnv.API_ROOT + "/salesOrder/delete", param);
}


//根据工序编号查询工序信息
export function queryProcessOne(factoryId, processCode) {
    return axios.get(devEnv.API_ROOT + "/process/getOne?factoryId=" + factoryId + "&processCode=" + processCode).then(res => res.data);
}

//根据工序编号查询对应的绩效工资配置
export function querySalarySetOne(factoryId, processCode, productCode, countBy) {
    return axios.get(devEnv.API_ROOT + "/salarySet/getOne?factoryId=" + factoryId + "&processCode=" + processCode + "&productCode=" + productCode + "&countType=" + countBy).then(res => res.data);
}



//查询指定工厂下指定类型的所有模板
export function queryPrintTemplateAll(factoryId, type) {
    return axios.get(devEnv.API_ROOT + "/api/getAll?factoryId=" + factoryId + "&type=" + type).then(res => res.data);
}

//打印预览接口
export function printPreview(id, templateId) {
    return req("post", devEnv.API_ROOT + "/api/print?id=" + id + "&templateId=" + templateId);
}

//保存模板
export function savePrintTemplate(param) {
    return req("post", devEnv.API_ROOT + "/api/save", param);
}
//删除模板
export function delPrintTemplate(id) {
    return axios.get(devEnv.API_ROOT + "/api/delete?id=" + id).then(res => res.data);
}


//产品报表
export function productReport(param) {
    return req("post", devEnv.API_ROOT + "/report/product", param);
}
//绩效报表
export function performanceReport(param) {
    return req("post", devEnv.API_ROOT + "/report/performance", param);
}
//不良品项报表
export function nongoodReport(param) {
    return req("post", devEnv.API_ROOT + "/report/nongood", param);
}
//产量统计报表
export function productCountReport(param) {
    return req("post", devEnv.API_ROOT + "/report/productCountReport", param);
}
//员工绩效报表
export function employeePerformanceReport(param) {
    return req("post", devEnv.API_ROOT + "/report/employeePerformanceReport", param);
}
//工资报表
export function salaryReport(param) {
    return req("post", devEnv.API_ROOT + "/report/salaryReport", param);
}
//生产报表
export function produceReport(param) {
    return req("post", devEnv.API_ROOT + "/report/produceReport", param);
}
//不良品项统计
export function nonGoodReport(param) {
    return req("post", devEnv.API_ROOT + "/report/nonGoodReport", param);
}

//报工模板下载
export function reportTempDownLoad() {
    return axios.get(devEnv.API_ROOT + "/enter/downloadTemplate").then(res => res.data);
}

//报工批量导入
export function reportBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/enter/importData", formData);
}
//报工批量审批
export function reportBatchApproval(formData) {
    return req("post", devEnv.API_ROOT + "/enter/batchApprove", formData);
}

//产品模板下载
export function productTempDownLoad() {
    return axios.get(devEnv.API_ROOT + "/product/downloadTemplate").then(res => res.data);
}

//产品批量导入
export function productBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/product/importData", formData);
}

//不良品项模板下载
export function nongoodTempDownLoad() {
    return axios.get(devEnv.API_ROOT + "/nongood/downloadTemplate").then(res => res.data);
}

//不良品项批量导入
export function nongoodBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/nongood/importData", formData);
}

//工单模板下载
export function orderTempDownLoad() {
    return axios.get(devEnv.API_ROOT + "/order/downloadTemplate").then(res => res.data);
}

//工单批量导入
export function orderBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/order/importData", formData);
}

//工序模板下载
export function workProcedureDownLoad() {
    return axios.get(devEnv.API_ROOT + "/process/downloadTemplate").then(res => res.data);
}

//工序批量导入
export function workProcedureBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/process/importData", formData);
}

//工艺路线模板下载
export function processRouteDownLoad() {
    return axios.get(devEnv.API_ROOT + "/technology/downloadTemplate").then(res => res.data);
}

//工艺路线批量导入
export function processRouteBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/technology/importData", formData);
}
//用户模板下载
export function userDownLoad() {
    return axios.get(devEnv.API_ROOT + "/user/downloadTemplate").then(res => res.data);
}

//用户批量导入
export function userBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/user/importData", formData);
}

//绩效工资配置模板下载
export function salarySetDownLoad() {
    return axios.get(devEnv.API_ROOT + "/salarySet/downloadTemplate").then(res => res.data);
}

//绩效工资配置批量导入
export function salarySetBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/salarySet/importData", formData);
}

//销售订单模板下载
export function goodsDownLoad() {
    return axios.get(devEnv.API_ROOT + "/salesOrder/downloadTemplate").then(res => res.data);
}

//销售订单批量导入
export function goodsBatchImp(formData) {
    return req("post", devEnv.API_ROOT + "/salesOrder/importData", formData);
}
//导出excel
export function exportExcel(param) {
    return req("post", devEnv.API_ROOT + "/api/exportExcel", param);
}


// WEBPACK FOOTER //
// ./src/api/business.js